'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import UsersController from "./controller/users";
import AccountController from "./controller/account";
import UserModalCreateController from "./controller/userModalCreate";
import UserTableDirective from "./directive/userTable";
import UserService from "./service/user";

export default angular.module('investmentProject.user', [])
    .controller('UsersController', UsersController)
    .controller('AccountController', AccountController)
    .controller('UserModalCreateController', UserModalCreateController)
    .directive('userTable', UserTableDirective)
    .factory('UserService', UserService)
    .name;